/**
 * useLeaderboard Hook (Web)
 * Thin wrapper around shared useLeaderboard
 */

import { useAuth } from '@contexts/AuthContext';
import { createHttpClient } from '@parlay-picker/shared/api/httpClient';
import {
  type UseLeaderboardOptions as SharedOptions,
  type UseLeaderboardResult,
  useLeaderboard as useLeaderboardShared,
} from '@parlay-picker/shared/hooks';
import { useMemo } from 'react';
import { API_BASE_URL } from '../config/api';

type WebLeaderboardOptions = Omit<SharedOptions, 'httpClient'>;

export function useLeaderboard(options: WebLeaderboardOptions = {}): UseLeaderboardResult {
  const { authFetch, isAuthenticated } = useAuth();

  const httpClient = useMemo(
    () =>
      createHttpClient({
        authFetch: isAuthenticated ? authFetch : (url, init) => fetch(url, init),
        baseUrl: API_BASE_URL,
      }),
    [authFetch, isAuthenticated],
  );

  return useLeaderboardShared({ ...options, httpClient });
}
